import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { ChallengeTypeApi } from '../types/api/challenges';
import type {
  ChallengeConsentUpdatePayload,
  ChallengeReduxState,
} from '../types/models/challenges';

type StateWithUser = { user: { userData?: { token?: string } | null } };

export const challengesApiSlice = createApi({
  reducerPath: 'challengesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as StateWithUser).user.userData?.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    fetchChallenge: builder.query<ChallengeReduxState & { message?: string }, ChallengeTypeApi>({
      query: (challengeType) => `/challenges/${challengeType}`,
    }),
    updateChallengesConsent: builder.mutation<ChallengeConsentUpdatePayload, string>({
      query: (challengeId) => ({
        url: `/challenges/addConsent/${challengeId}`,
        method: 'PUT',
      }),
    }),
    removeChallengesConsent: builder.mutation<ChallengeConsentUpdatePayload, string>({
      query: (challengeId) => ({
        url: `/challenges/removeConsent/${challengeId}`,
        method: 'PUT',
      }),
    }),
  }),
});

export const {
  useFetchChallengeQuery,
  useUpdateChallengesConsentMutation,
  useRemoveChallengesConsentMutation,
} = challengesApiSlice;
